import {observer} from "mobx-react-lite";
import {useRouterStore} from "mobx-state-router";
import {FormattedMessage, useIntl} from "react-intl";
import React, {useContext} from "react";
import {StateContext} from "../../../../../App";
import {Button, Col, CustomInput, FormGroup, Label, Row} from "reactstrap";
import {types} from "mobx-state-tree";


export const FormatModalState = types.model("FormatModalState", {
  selectedFormat: types.optional(types.string, "CSV")
}).actions(self => ({
  updateExportFormat(format) {
    self.selectedFormat = format;
  },
}))

export const FormatModal = observer(({store, currentState}) => {
  const routerStore = useRouterStore();
  const { params } = routerStore.routerState;

  const intl = useIntl();
  const stateContext = useContext(StateContext);

  return (
    <>
      <Row className="p-1">
        <Label sm={2} className="text-sm-right">
          <FormattedMessage
            id="data.exports.settings.format.defaultMessage"
            defaultMessage="Format"
          />
        </Label>
        <Col sm={10}>
          <CustomInput
            type="select"
            className="react-select-container"
            classNamePrefix="react-select"
            value={store?.selectedFormat}
            id={store?.selectedFormat}
            defaultValue={store?.selectedFormat}
            onChange={(data) => store?.updateExportFormat(data.target.value)}
          >
            <option value={'CSV'}>CSV</option>
            <option value={'JSON'}>JSON</option>
          </CustomInput>
        </Col>
      </Row>
      <Row className="p-1">
        <Col>
          <FormGroup row>
            <Col sm={2}>
              <Button
                className="btn-outline-secondary mr-1"
                color="secondary"
                id="cancel-btn"
                onClick={() => {
                  currentState.modalStore.toggle();
                  store?.updateExportFormat(currentState?.format);
                }}
              >
                <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.cancel.defaultMessage"/>
              </Button>
            </Col>
            <Col sm={10} className="text-right">
              <Button
                outline
                color="primary"
                onClick={() => {
                  currentState?.updateExportFormat(store?.selectedFormat);
                  currentState.modalStore.toggle();
                }}
              >
                <FormattedMessage id="createQr.advancedConfigsOptions.modalButtons.apply.defaultMessage"/>
              </Button>
            </Col>
          </FormGroup>
        </Col>
      </Row>
    </>
  );
});

